// extracted by mini-css-extract-plugin
export default {"header":"header__sqF5","scrolled":"scrolled_cXNGm","listWrapper":"listWrapper_UzHPs","list":"list_mB75n","container":"container_LTfF4","logo":"logo_Atx_z","arrow":"arrow_m37XM"};